export default __webpack_public_path__ + "static/media/id-billing-picturemark-l.972d55f6.svg";